(() => {
 'use strict';
 const dialog=document.getElementById('ww-offer-dialog'),configNode=document.getElementById('ww-offer-config');
 if(!dialog||!configNode||typeof dialog.showModal!=='function')return;
 let config;try{config=JSON.parse(configNode.textContent);}catch{return;}
 const text=config.text,root=config.root.replace(/\/$/,''),ar=document.documentElement.lang.startsWith('ar');
 const money=new Intl.NumberFormat('en-US',{maximumFractionDigits:2});
 const format=value=>money.format(value/100)+' EGP';
 const cartLoading=ar?'جارٍ تحديث العربة…':'Updating your cart…';
 const cartUnavailable=ar?'تمت الإضافة. تعذّر تحديث الإجمالي هنا؛ راجعه في العربة.':'Added to your cart. View the cart to check your updated total.';
 let cartFresh=true,lastAddCandidate=null;
 const grid=dialog.querySelector('[data-offer-grid]'),status=dialog.querySelector('[data-offer-status]');
 let groups=[],loadedProfile='',rotationTimer=0,rotationPaused=matchMedia('(prefers-reduced-motion: reduce)').matches;
 function recommendationProfile(value){
  const watch=value.items.find(item=>item.mens_watch||item.womens_watch);
  if(watch)return watch.womens_watch?'women':'men';
  return value.items.find(item=>item.audience)?.audience||config.productProfile||'mixed';
 }
 function recommendations(profile){
  const perfume={key:'perfume',handle:profile==='women'?'perfume-for-womens':'perfume-for-mens'};
  if(profile==='women')return [{key:'men',handle:'watches-for-mens'},{key:'bags',handle:'bags-for-womens'},perfume];
  if(profile==='men')return [{key:'women',handle:'watches-for-womens'},{key:'pens',handle:'luxury-pens'},{key:'wallets',handle:'wallets-for-mens'},perfume];
  return [{key:'men',handle:'watches-for-mens'},{key:'women',handle:'watches-for-womens'},perfume];
 }
 function canOpen(value){return value.currency==='EGP'&&Number(value.subtotal)>config.trigger;}
 let cart=config.cart,loaded=null,busy=false,refreshTimer=0,wantsOpen=false,wantsForcedOpen=false,returnFocus=null;
 const seen=new Set();try{JSON.parse(sessionStorage.getItem('ww-offer-seen-v1')||'[]').forEach(id=>seen.add(id));}catch{}
 function withPreview(path){
  const url=new URL(path,location.origin),current=new URL(location.href);
  if(current.searchParams.has('preview_theme_id'))url.searchParams.set('preview_theme_id',current.searchParams.get('preview_theme_id'));
  return url.href;
 }
 async function getJSON(path){
  const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),5000);
  try{
   const response=await fetch(withPreview(path),{credentials:'same-origin',cache:'no-store',headers:{Accept:path.includes('view=ww-offer-data')?'text/html':'application/json'},signal:controller.signal});
   if(!response.ok)throw new Error('request');
   return await response.json();
  }finally{clearTimeout(timer);}
 }
 function offerState(value){
  const subtotal=Number(value.subtotal)||0;
  return {remaining:Math.max(0,config.threshold-subtotal),progress:Math.min(config.threshold,Math.max(0,subtotal)),applied:(value.discounts||[]).some(d=>(config.discountTitles||[config.discountTitle]).includes(d.title)&&Number(d.amount)>=config.discount)};
 }
 function updateTotals(){
  if(!cartFresh){
   dialog.querySelector('[data-offer-progress]').removeAttribute('value');
   dialog.querySelector('[data-offer-progress-text]').textContent=cartLoading;
   dialog.querySelector('[data-offer-total]').textContent='—';
   return;
  }
  const state=offerState(cart),progress=dialog.querySelector('[data-offer-progress]');
  progress.value=state.progress;
  dialog.querySelector('[data-offer-progress-text]').textContent=state.applied?text.qualified:state.remaining===0?text.eligible:text.remaining.replace('{amount}',format(state.remaining));
  dialog.querySelector('[data-offer-total]').textContent=format(Number(cart.total)||0);
 }
 function announce(message,error=false){status.textContent=message;status.classList.toggle('is-error',error);}
 function node(tag,className,content){
  const element=document.createElement(tag);if(className)element.className=className;
  if(content!==undefined)element.textContent=content;return element;
 }
 function productLink(product){
  const url=new URL(product.url,location.origin);
  if(!url.pathname.startsWith(root+'/')&&root)url.pathname=root+url.pathname;
  return withPreview(url.href);
 }
 function usableProducts(products){
  return (Array.isArray(products)?products:[]).filter(product=>product.id&&product.url&&product.image);
 }
 function choicesFor(group){
  const inCart=new Set(cart.items.map(item=>Number(item.product_id)));
  return usableProducts(group.products).filter(product=>!inCart.has(Number(product.id)));
 }
 function selectProduct(group,advance=false){
  const choices=choicesFor(group),current=choices.find(product=>String(product.id)===String(group.currentId));
  if(current&&!advance)return current;
  const alternatives=choices.filter(product=>String(product.id)!==String(group.currentId));
  const pool=alternatives.length?alternatives:choices;
  const selected=pool[Math.floor(Math.random()*pool.length)];
  group.currentId=selected?.id;return selected;
 }
 function drawGroup(group,advance=false){
  const slot=grid.querySelector('[data-offer-group="'+group.key+'"]');if(!slot)return;
  if(!slot.childElementCount){
   slot.append(node('h3','ww-offer__category',text[group.key]));
   const imageLink=node('a','ww-offer__image');imageLink.hidden=true;
   const image=node('img');image.width=540;image.height=540;image.decoding='async';imageLink.append(image);
   image.addEventListener('error',()=>{
    if(image.dataset.fallback&&image.src!==image.dataset.fallback){image.src=image.dataset.fallback;return;}
    group.products=group.products.filter(product=>String(product.id)!==String(group.currentId));drawGroup(group,true);
   });
   const browse=node('a','ww-offer__browse',text.browse);browse.href=withPreview(root+'/collections/'+group.handle);
   browse.setAttribute('aria-label',text.browse+' - '+text[group.key]);slot.append(imageLink,browse);
  }
  const product=selectProduct(group,advance),imageLink=slot.querySelector('.ww-offer__image');
  imageLink.hidden=!product;if(!product)return;
  if(imageLink.dataset.productId===String(product.id))return;
  imageLink.dataset.productId=String(product.id);imageLink.href=productLink(product);imageLink.setAttribute('aria-label',product.title);
  const image=imageLink.querySelector('img');image.alt=product.title;image.dataset.fallback=product.fallbackImage?new URL(product.fallbackImage,location.origin).href:'';image.src=product.image;
 }
 const rotationButton=dialog.querySelector('[data-offer-rotation]');
 function syncRotationButton(){
  if(!rotationButton)return;
  rotationButton.textContent=rotationPaused?text.resume_rotation:text.pause_rotation;
  rotationButton.setAttribute('aria-pressed',String(rotationPaused));
 }
 function stopRotation(){clearInterval(rotationTimer);rotationTimer=0;}
 function startRotation(){
  stopRotation();
  rotationTimer=setInterval(()=>{
   if(!dialog.open||document.hidden||rotationPaused)return;
   groups.forEach(group=>{
    const slot=grid.querySelector('[data-offer-group="'+group.key+'"]');
    if(slot?.matches(':hover')||slot?.contains(document.activeElement))return;
    drawGroup(group,true);
   });
  },3000);
 }
 rotationButton?.addEventListener('click',()=>{rotationPaused=!rotationPaused;syncRotationButton();});
 syncRotationButton();
 async function loadProducts(){
  const profile=recommendationProfile(cart);
  if(loaded&&loadedProfile===profile)return loaded;
  loadedProfile=profile;groups=recommendations(profile);
  grid.style.setProperty('--ww-offer-columns',String(groups.length));grid.replaceChildren();
  groups.forEach(group=>{
   group.products=usableProducts(config.catalog?.[group.handle]?.products);
   const card=node('article','ww-offer__card');card.dataset.offerGroup=group.key;grid.append(card);drawGroup(group);
  });
  grid.setAttribute('aria-busy','true');announce(groups.every(group=>choicesFor(group).length)?'':text.loading);
  const activeGroups=groups;
  loaded=Promise.allSettled(activeGroups.map(async group=>{
   const seed=config.catalog?.[group.handle];
   const pageCount=Math.max(1,Number(seed?.pages)||1),firstPage=1+Math.floor(Math.random()*pageCount);
   const pages=[...new Set([firstPage,1,Math.min(pageCount,firstPage+1)])];
   for(const page of pages){
    const data=await getJSON(root+'/collections/'+group.handle+'?view=ww-offer-data&page='+page);
    const byId=new Map(group.products.map(product=>[String(product.id),product]));
    usableProducts(data.products).forEach(product=>byId.set(String(product.id),product));group.products=[...byId.values()];
    if(groups!==activeGroups)return;
    drawGroup(group);if(choicesFor(group).length>=3)break;
   }
  })).then(()=>{
   if(groups!==activeGroups)return;
   grid.setAttribute('aria-busy','false');
   const missing=activeGroups.some(group=>!choicesFor(group).length);
   if(!status.classList.contains('is-error'))announce(missing?text.partial_error:'');
   if(missing)loaded=null;
  });
  return loaded;
 }
 let cartReadVersion=0;
 function normalizeCart(value){
  if(!Array.isArray(value.items)||!Number.isFinite(Number(value.items_subtotal_price)))throw new Error('cart');
  return {currency:value.currency,subtotal:value.items_subtotal_price,total:value.total_price,count:value.item_count,
   items:value.items.map(item=>{const known=cart.items.find(previous=>Number(previous.product_id)===Number(item.product_id));
    return {...known,product_id:item.product_id,variant_id:item.variant_id,quantity:item.quantity};}),
   discounts:(value.cart_level_discount_applications||[]).map(item=>({title:item.title,amount:item.total_allocated_amount}))};
 }
 async function refresh(){
  const version=++cartReadVersion;
  let next;
  try{next=normalizeCart(await getJSON(root+'/cart.js'));}
  catch{
   next=await getJSON(root+'/cart?view=ww-offer-data');
   if(!Array.isArray(next.items)||!Number.isFinite(Number(next.subtotal)))throw new Error('cart');
  }
  if(version!==cartReadVersion)return cart;
  cart=next;cartFresh=true;updateTotals();
  if(!cart.items.length){seen.clear();try{sessionStorage.removeItem('ww-offer-seen-v1');}catch{}}
  // Category enrichment must never block the dialog or the canonical cart totals.
  getJSON(root+'/cart?view=ww-offer-data').then(context=>{
   if(version!==cartReadVersion||!Array.isArray(context.items))return;
   cart.items=cart.items.map(item=>({...item,...context.items.find(line=>Number(line.variant_id)===Number(item.variant_id))}));
   if(dialog.open)loadProducts();
  }).catch(()=>{});
  return cart;
 }
 function remember(ids){ids.forEach(id=>seen.add(id));try{sessionStorage.setItem('ww-offer-seen-v1',JSON.stringify([...seen]));}catch{}}
 async function openOffer(force=false,pending=false){
  if((!pending&&!canOpen(cart))||dialog.open||(!force&&seen.has('cart')))return false;
  returnFocus=document.activeElement;updateTotals();
  const cartLink=dialog.querySelector('[data-offer-cart]');cartLink.href=withPreview(root+'/cart');cartLink.textContent=text.cart;
  dialog.querySelector('[data-offer-order]').href=withPreview(root+'/checkout');
  try{
   loadProducts();
   const drawerClose=document.querySelector('#t4s-mini_cart[aria-hidden="false"] [data-drawer-close]');
   if(drawerClose)drawerClose.click();
   dialog.showModal();startRotation();document.documentElement.classList.add('ww-offer-open');remember(['cart']);
   dialog.querySelector('[data-offer-close]')?.focus({preventScroll:true});return true;
  }catch{announce(text.error,true);return false;}
 }
 function schedule(open=false,force=false){
  wantsOpen=wantsOpen||open;wantsForcedOpen=wantsForcedOpen||force;clearTimeout(refreshTimer);
  refreshTimer=setTimeout(async()=>{
   const requested=wantsOpen,forced=wantsForcedOpen;wantsOpen=false;wantsForcedOpen=false;
   try{
    await refresh();
    if(dialog.open){if(canOpen(cart)){loadProducts();groups.forEach(group=>drawGroup(group));}else if(!busy)dialog.close();}
    else if(requested)await openOffer(forced);
   }catch{
    if(dialog.open){dialog.querySelector('[data-offer-progress-text]').textContent=cartUnavailable;announce(cartUnavailable,true);}
   }
  },180);
 }

 const buyPairs=new WeakSet(),buyVariants=new WeakMap();
 function selectedBuyVariant(pair){
  const form=pair.closest('form'),id=form?.elements.namedItem('id')?.value;
  return (buyVariants.get(pair)||[]).find(variant=>String(variant.id)===String(id));
 }
 function syncBuyButtons(){
  document.querySelectorAll('.ww-buy-now-pair').forEach(pair=>{
   if(!buyPairs.has(pair)){
    try{buyVariants.set(pair,JSON.parse(pair.querySelector('[data-ww-buy-now-variants]').textContent));}catch{return;}
    pair.querySelector('[data-ww-buy-now]').addEventListener('click',()=>buyNow(pair));buyPairs.add(pair);
   }
   const variant=selectedBuyVariant(pair),eligible=cart.currency==='EGP'&&variant?.available&&Number(variant.price)>config.trigger;
   pair.querySelector('[data-ww-buy-now]').hidden=!eligible;
   pair.querySelector('[data-ww-buy-now-native]').hidden=!!eligible;
  });
 }
 async function buyNow(pair){
  if(busy)return;
  const variant=selectedBuyVariant(pair),form=pair.closest('form'),button=pair.querySelector('[data-ww-buy-now]'),message=pair.querySelector('[data-ww-buy-now-status]');
  if(!variant?.available||Number(variant.price)<=config.trigger){syncBuyButtons();return;}
  if(!form.reportValidity())return;
  const missing=[...form.querySelectorAll('[data-field-required]')].find(field=>{
   const wrapper=field.closest('[data-item-property-field]');
   if(wrapper?.matches('.is--type-radio,.is--type-checkbox'))return !wrapper.querySelector('input:checked');
   return !String(field.value||'').trim();
  });
  if(missing){message.textContent=text.choose_required;message.hidden=false;missing.focus();return;}
  busy=true;button.disabled=true;message.hidden=true;let added=false;
  cartFresh=false;
  const navigationLinks=dialog.querySelectorAll('[data-offer-cart],[data-offer-order]');
  navigationLinks.forEach(link=>link.setAttribute('aria-disabled','true'));
  await openOffer(true,true);
  try{
   const response=await fetch(root+'/cart/add.js',{method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:new FormData(form)});
   const result=await response.json();
   if(!response.ok||result.status)throw new Error(typeof result.description==='string'?result.description:text.error);
   added=true;document.dispatchEvent(new CustomEvent('cart:refresh'));
   await refresh();
   if(dialog.open){loadProducts();groups.forEach(group=>drawGroup(group));announce('');}
  }catch(error){
   if(added){
    dialog.querySelector('[data-offer-progress-text]').textContent=cartUnavailable;announce(cartUnavailable,true);
   }else{
    dialog.close();message.textContent=error.message||text.error;message.hidden=false;
   }
  }finally{busy=false;button.disabled=false;navigationLinks.forEach(link=>link.removeAttribute('aria-disabled'));}
 }
 let buySyncTimer=0;
 function scheduleBuySync(){clearTimeout(buySyncTimer);buySyncTimer=setTimeout(syncBuyButtons,70);}
 syncBuyButtons();
 dialog.querySelectorAll('[data-offer-cart],[data-offer-order]').forEach(link=>link.addEventListener('click',event=>{
  if(busy||event.currentTarget.getAttribute('aria-disabled')==='true')event.preventDefault();
 }));
 // Capture only the displayed product's selected variant; no estimated totals are shown.
 document.addEventListener('click',event=>{
  const button=event.target.closest('[data-atc-form]');if(!button)return;
  const form=button.closest('form'),id=form?.elements.namedItem('id')?.value;
  let variant;
  document.querySelectorAll('.ww-buy-now-pair').forEach(pair=>{
   variant=variant||(buyVariants.get(pair)||[]).find(item=>String(item.id)===String(id));
  });
  lastAddCandidate=variant?.available?{price:Number(variant.price),quantity:Math.max(1,Number(form?.elements.namedItem('quantity')?.value)||1),time:Date.now()}:null;
 },true);
 document.addEventListener('change',scheduleBuySync);
 if(window.jQuery_T4NT)window.jQuery_T4NT(document).on('change.wwOffer','form[data-type="add-to-cart-form"]',scheduleBuySync);
 new MutationObserver(records=>{if(records.some(record=>[...record.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('.ww-buy-now-pair')||n.querySelector?.('.ww-buy-now-pair')))))scheduleBuySync();}).observe(document.body,{childList:true,subtree:true});

 dialog.querySelectorAll('[data-offer-close]').forEach(button=>button.addEventListener('click',()=>dialog.close()));
 dialog.addEventListener('click',event=>{
  if(event.target!==dialog)return;
  const rect=dialog.getBoundingClientRect();
  if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();
 });
 dialog.addEventListener('close',()=>{
  stopRotation();
  document.documentElement.classList.remove('ww-offer-open');
  if(returnFocus?.isConnected&&!returnFocus.closest('[aria-hidden="true"]'))returnFocus.focus({preventScroll:true});
 });
 document.addEventListener('cart:updated',()=>schedule());
 let themeEventsBound=false;
 function bindThemeEvents(){
  if(themeEventsBound||!window.jQuery_T4NT)return;
  themeEventsBound=true;
  window.jQuery_T4NT(document).on('add:cart:success.wwOffer',()=>{
   const immediate=canOpen(cart)||(lastAddCandidate&&Date.now()-lastAddCandidate.time<15000&&lastAddCandidate.price*lastAddCandidate.quantity>config.trigger);
   lastAddCandidate=null;
   if(immediate){cartFresh=false;openOffer(true,true);}
   schedule(true,true);
  });
 }
 bindThemeEvents();document.addEventListener('DOMContentLoaded',bindThemeEvents);window.addEventListener('load',bindThemeEvents);
 if('PerformanceObserver' in window){try{
  new PerformanceObserver(list=>{for(const entry of list.getEntries()){
   const path=new URL(entry.name,location.origin).pathname;
   if(!busy&&(path.endsWith('/cart/add.js')||path.endsWith('/cart/add'))&&(!entry.responseStatus||(entry.responseStatus>=200&&entry.responseStatus<300)))schedule(true,true);
  }}).observe({type:'resource',buffered:false});
 }catch{}}
 window.addEventListener('pageshow',event=>{if(event.persisted&&dialog.open)schedule();});
 if(document.body.classList.contains('template-cart')&&canOpen(cart))setTimeout(()=>schedule(true),500);
})();
